export default __webpack_public_path__ + "static/media/lock.7ab5eed4.svg";